import { Button, Flex, Heading, Text, VStack } from '@ritualco/jutsu'
import { CardPage } from 'components/PageTemplates'
import { useContent } from 'lib/content/react'

export type CompanyExistsProps = {
  companyName?: string
  onExit: () => void
}

const CompanyExists = ({ companyName = '', onExit }: CompanyExistsProps) => {
  const { formatMessage } = useContent()

  return (
    <CardPage trackingName="CompanyExists">
      <Flex flexDir="column" textAlign="center" textColor="grayscale.primary">
        <VStack mb={52} spacing={2}>
          <Text fontSize="smalls">
            {formatMessage({ id: 'pmportal.onboarding.requestSetup' })}
          </Text>
          <Heading fontSize="3xlarge" fontWeight="semibold">
            {formatMessage(
              { id: 'pmportal.onboarding.teamAlreadyOnRitual' },
              { companyName }
            )}
          </Heading>
          <Text fontSize="small" letterSpacing="wide">
            {formatMessage({ id: 'pmportal.onboarding.existsDesc' })}
          </Text>
        </VStack>
        <Button marginLeft="auto" onClick={() => onExit()}>
          {formatMessage({ id: 'pmportal.onboarding.learnMore' })}
        </Button>
      </Flex>
    </CardPage>
  )
}

export default CompanyExists
